import React from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from 'contexts/User';
import { userHasPrivileges } from 'lib/helpers/renderCondition';
import Privileges from 'lib/constants/privileges';

export default function SiteLink({siteId, style, children}) {
    return <UserContext.Consumer>
        {({state}) => userHasPrivileges([Privileges.READ_SITES], state.user)
            ? <Link to={`/sites/${siteId}`} style={style}>{children}</Link>
            : children}
    </UserContext.Consumer>;
}
